import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'services',
    component: Children,

    children: [
      {
        path: '',
        name: 'services',
        component: () => import('../pages/ServicesPage.vue')
      },
      {
        path: 'customer-service',
        component: Children,
        children: [
          {
            path: 'create',
            name: 'customer-service.create',
            component: () =>
              import('../pages/CustomerService/CustomerServiceCreatePage.vue')
          },
          {
            path: ':id',
            name: 'customer-service.show',
            component: () =>
              import('../pages/CustomerService/CustomerServiceShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':id/edit',
            name: 'customer-service.edit',
            component: () =>
              import('../pages/CustomerService/CustomerServiceEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      },
      {
        path: 'internal-service',
        component: Children,
        children: [
          {
            path: 'create',
            name: 'internal-service.create',
            component: () =>
              import('../pages/InternalService/InternalServiceCreatePage.vue')
          },
          {
            path: ':id',
            name: 'internal-service.show',
            component: () =>
              import('../pages/InternalService/InternalServiceShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':id/edit',
            name: 'internal-service.edit',
            component: () =>
              import('../pages/InternalService/InternalServiceEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      }
    ]
  }
];

export default routes;
